module.exports = __webpack_public_path__ + "static/media/icon-reply.37a0328d.svg";